import React, { useState } from "react";
import Auth from "../Auth";
import "../styles/welcome.css";
import { motion } from "framer-motion";
import heroImage from "../assets/hero-illustration.png"; // Import the image from src/assets

const WelcomePage = () => {
  const [showLogin, setShowLogin] = useState(false);

  return (
    <div className="welcome-wrapper">
      {/* 🔘 Floating Top Right Nav */}
      <motion.div
        className="nav-buttons"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        <a href="/register">Register</a>
        <a href="/pricing">Pricing</a>
        <a href="/terms">Terms</a>
        <button onClick={() => setShowLogin(true)}>Login</button>
      </motion.div>

      {/* 💬 Floating Support */}
      <motion.div
        className="floating-support"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
        <p>💬 Need help?</p>
        <a href="mailto:support@tracksmartng.com">📧 Email</a>
        <a href="https://wa.me/2349027161192" target="_blank" rel="noreferrer">
          💬 WhatsApp
        </a>
        <a href="tel:+2349027161192">📞 Call</a>
      </motion.div>

      {/* 🌄 Hero Section */}
      <motion.div
        className="welcome-hero"
        style={{
          backgroundImage: `url(${heroImage})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2 }}
      >
        <div className="hero-overlay"></div>
        <motion.div
          className="hero-text"
          initial={{ opacity: 0, x: -60 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          <h2>Welcome to TrackSmart Solutions</h2>
          <h1>We track, analyse, and secure your fleet.</h1>
          <p>
            Your all-in-one vehicle tracking and fleet intelligence dashboard,
            designed to keep your fleet safe and efficient.
          </p>
          <div className="hero-buttons">
            <a href="/register" className="cta-button">
              Get Started
            </a>
            <a href="/pricing">View Pricing</a>
          </div>
        </motion.div>

        {/* 👇 Hero Quote */}
        <motion.p
          className="lower-tagline"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          <em>You will love our service!</em>
        </motion.p>
      </motion.div>

      {/* 🔐 Login Modal with Backdrop */}
      {showLogin && (
        <>
          <motion.div
            className="modal-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            onClick={() => setShowLogin(false)}
          />
          <motion.div
            className="welcome-login-modal"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.5 }}
          >
            <div className="welcome-login-box">
              <button
                className="close-btn"
                onClick={() => setShowLogin(false)}
              >
                ✖
              </button>
              <Auth />
            </div>
          </motion.div>
        </>
      )}
    </div>
  );
};

export default WelcomePage;